export default "__VITE_ASSET__m60lbu3a__"